import {Pipe, PipeTransform} from '@angular/core';
import {TranslatableString} from '../../../models/TranslatableString';
import {LanguageService} from '../../../services/languages/language.service';

@Pipe({
  name: 'translatedb',
  pure: false
})
export class TranslateDbPipe implements PipeTransform {
  key: string;
  
  constructor(private languageService: LanguageService) {
    this.languageService.currentLanguageKey.subscribe(k => this.key = k);
  }
  
  transform(ts: TranslatableString): any {
    if (this.key === 'bg') {
      return ts.valueBg;
    }
    if (this.key === 'en') {
      return ts.valueEn;
    }
    if (this.key === 'ru') {
      return ts.valueRu;
    }
  }
}
